import React from "react";
import { NoteItem } from "./NoteItem";
import style from "./assessmentNotes.module.scss";

export const NotesList = ({ notes, assessmentStage, onDeleteNote, hasPermission }) => {
  if (!Array.isArray(notes) || notes.length === 0) return null;

  return (
    <div className={style.notes_container}>
      {notes.map((data, index) => (
        <NoteItem key={index} data={data} assessmentStage={assessmentStage} onDelete={onDeleteNote} hasPermission={hasPermission} />
      ))}
    </div>
  );
};
